import { useDictionary } from '@/contexts/DictionaryContext'
import { useCallback } from 'react'
import type { IUser } from '@/types/user'

export default function useUsersDictionary() {
  const { getDictionary } = useDictionary()

  const getUsers = useCallback(() => {
    return getDictionary('users') as IUser[] | undefined
  }, [getDictionary])

  return {
    getUsers,
  }
}
